export default __webpack_public_path__ + "static/media/news108.898e0e76.jpg";